export enum HalfSelectionSideType {
  LEFT = 'left',
  RIGHT = 'right',
}
